import { useState } from "react";
import { Button, Modal } from "antd";
import { ArrowLeftOutlined, CloseOutlined } from "@ant-design/icons";
import AccountForm from "./mobile/accountForm";
import AddEditBankAccount from "./bank/addEditBankAccount";
import mobileMoney from "../../../assets/images/mobileMoney.png";
import cardMoney from "../../../assets/images/cardMoney.png";
import "../utils/accountType.css";

const SelectAccountTypeModal = ({ open, onClose, selectedPaymentAccount }) => {
  const [accountType, setAccountType] = useState(null);

  const handleBack = () => {
    setAccountType(null);
  };

  const handleClose = () => {
    setAccountType(null);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      closeIcon={<CloseOutlined style={{ fontSize: 18 }} />}
    >
      <div className="modal-container">
        <div className="modal-header d-flex align-items-center mb-4">
            {accountType && (
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={handleBack}
                type="text"
                className="me-2 p-0 border-0 bg-transparent"
              />
            )}
            <h5 className="fw-bold mb-0 flex-grow-1 text-center">
              Ajouter un nouveau compte
            </h5>
        </div>

        {!accountType && (
          <>
            <div
              onClick={() => setAccountType("MOBILE_MONEY")}
              className="account-type-card mb-3 d-flex align-items-center p-3 rounded border"
              style={{ cursor: "pointer" }}
            >
              <img
                src={mobileMoney}
                alt="mobile money"
                className="account-type-icon me-3"
              />
              <div>
                <strong>Mobile Money</strong>
                <div className="text-muted small">
                  Orange Money, MTN, Moov, ...
                </div>
              </div>
            </div>

            <div
              onClick={() => setAccountType("BANK_CARD")}
              className="account-type-card d-flex align-items-center p-3 rounded border mb-4"
              style={{ cursor: "pointer" }}
            >
              <img
                src={cardMoney}
                alt="carte bancaire"
                className="account-type-icon me-3"
              />
              <div>
                <strong>Virement bancaire</strong>
                <div className="text-muted small">Compte bancaire</div>
              </div>
            </div>
          </>
        )}

        {accountType === "MOBILE_MONEY" && (
          <AccountForm selectedPaymentAccount={selectedPaymentAccount} onClose={handleClose}/>
        )}

        {accountType === "BANK_CARD" && <AddEditBankAccount selectedPaymentAccount={selectedPaymentAccount} onClose={handleClose}/>}
      </div>
    </Modal>
  );
};

export default SelectAccountTypeModal;
